export const SIDEBAR_CONTAINER_CLASSES = {
  vertical: "sb-account-settings-sidebar-vertical",
  horizontal: "sb-account-settings-sidebar-horizontal",
  horizontalBurger: "sb-account-settings-sidebar-horizontal-burger",
};
export const BURGER_BUTTON_CLASSES =
  "sb-account-settings-sidebar-burger-button sb-rounded-lg sb-cursor-pointer";
export const BURGER_LABEL_CLASSES =
  "sb-account-settings-sidebar-burger-label sb-font-medium";
export const MOBILE_DRAWER_CLASSES =
  "mobile-sidebar-drawer sb-account-settings-sidebar-mobile-drawer sb-transform sb-transition-all sb-duration-300 sb-ease-in-out";
export const MOBILE_OVERLAY_CLASSES =
  "mobile-sidebar-overlay sb-account-settings-sidebar-mobile-overlay sb-transition-opacity sb-duration-300 sb-ease-in-out";
